<template>
  <div class="order-page">
    <!-- <h1>钻展定向</h1> -->
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :data="form"
               label-width="130px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="plan_info"
                          label="计划基本信息">
              <el-input v-model="form.plan_info"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="130px"
                          prop="tgdy_info"
                          label="推广单元基本信息">
              <el-input v-model="form.tgdy_info"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="name"
                          label="定向名称">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label-width
                          prop="create_time"
                          label="日期">
              <!-- <el-input v-model="form.create_time"></el-input> -->
              <el-date-picker v-model="form.create_time"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithImport"></action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              border>
			  
     <el-table-column prop="create_time"
	   align="center"
	   header-align="center"
	   label="时间"
	   width="100px"></el-table-column>
      <el-table-column prop="name"
                       align="center"
                       header-align="center"
                       label="受众人群名称"
                       min-width="130px"
                       show-overflow-tooltip></el-table-column>
					   
      <el-table-column prop="plan_info"
                       align="center"
                       header-align="center"
                       label="计划基本信息"
                       min-width="120px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="plan_group"
                       align="center"
                       header-align="center"
                       label="计划组基本信息"
                       min-width="180px"
                       show-overflow-tooltip></el-table-column>
					   
					   
		    <el-table-column prop="qcxqrs"
                       align="center"
                       header-align="center"
                       label="浅层兴趣行为流转人数"
                       min-width="180px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="sdxqrs"
                       align="center"
                       header-align="center"
                       label="深度兴趣行为流转人数"
                       width="100px"></el-table-column>		



      <el-table-column prop="gmxwrs"
                       align="center"
                       header-align="center"
                       label="购买行为流转人数"
                       min-width="120px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="qcxqcb"
                       align="center"
                       header-align="center"
                       label="浅层兴趣行为平均流转成本(元)"
                       min-width="180px"
                       show-overflow-tooltip></el-table-column>
	      <el-table-column prop="sdxqcb"
                       align="center"
                       header-align="center"
                       label="深度兴趣行为平均流转成本(元)"
                       min-width="180px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="gmxwcb"
                       align="center"
                       header-align="center"
                       label="购买行为平均流转成本(元)"
                       width="100px"></el-table-column>					   
					   
					   
					   
					   
      <el-table-column prop="zx"
                       align="center"
                       header-align="center"
                       label="展现"></el-table-column>
      <el-table-column prop="dj"
                       align="center"
                       header-align="center"
                       label="点击"></el-table-column>
      <el-table-column prop="xh"
                       align="center"
                       header-align="center"
                       label="消耗"></el-table-column>
      <el-table-column prop="ctr"
                       align="center"
                       header-align="center"
                       label="点击率"></el-table-column>
      <el-table-column prop="djdj"
                       align="center"
                       header-align="center"
                       label="点击单价"></el-table-column>
      <el-table-column prop="qczxcb"
                       align="center"
                       header-align="center"
                       label="千次展现成本"></el-table-column>
					   
					   
					   
					   
      <el-table-column prop="zxrs"
                       align="center"
                       header-align="center"
                       label="展现人数"></el-table-column>
      <el-table-column prop="sdjdliang"
                       align="center"
                       header-align="center"
                       label="深度进店量"></el-table-column>
      <el-table-column prop="fksc"
                       align="center"
                       header-align="center"
                       label="访客时长"></el-table-column>
      <el-table-column prop="fkyms"
                       align="center"
                       header-align="center"
                       label="访客页面数"></el-table-column>
					   
					   
					   
	 <el-table-column prop="scbbs"
                       align="center"
                       header-align="center"
                       label="收藏宝贝量"></el-table-column>
      <el-table-column prop="scdpliang"
                       align="center"
                       header-align="center"
                       label="收藏店铺量"></el-table-column>
      <el-table-column prop="tjgwcliang"
                       align="center"
                       header-align="center"
                       label="添加购物车量"></el-table-column>
      <el-table-column prop="pxddliang"
                       align="center"
                       header-align="center"
                       label="拍下订单量"></el-table-column>




	 <el-table-column prop="pxddje"
                       align="center"
                       header-align="center"
                       label="拍下订单金额"></el-table-column>
      <el-table-column prop="pxddliang"
                       align="center"
                       header-align="center"
                       label="成交订单量"></el-table-column>
      <el-table-column prop="pxddje"
                       align="center"
                       header-align="center"
                       label="成交订单金额"></el-table-column>
      <el-table-column prop="djzhlv"
                       align="center"
                       header-align="center"
                       label="点击转化率(%)"></el-table-column>


	 <el-table-column prop="roi"
                       align="center"
                       header-align="center"
                       label="投资回报率"></el-table-column>
      <el-table-column prop="hfliang"
                       align="center"
                       header-align="center"
                       label="回访量"></el-table-column>
      <el-table-column prop="hfcb"
                       align="center"
                       header-align="center"
                       label="回访成本"></el-table-column>
      <el-table-column prop="scjgcb"
                       align="center"
                       header-align="center"
                       label="收藏加购成本"></el-table-column>
					   
					   
	 <el-table-column prop="hsliang"
                       align="center"
                       header-align="center"
                       label="回搜量"></el-table-column>
      <el-table-column prop="hscb"
                       align="center"
                       header-align="center"
                       label="回搜成本"></el-table-column>
      <el-table-column prop="ysddliang"
                       align="center"
                       header-align="center"
                       label="预售订单量"></el-table-column>
      <el-table-column prop="ysddje"
                       align="center"
                       header-align="center"
                       label="预售订单金额"></el-table-column>
					   
					   
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="110px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <import-dialog @submit="handleFile"
                   ref="refImportDialog" />
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import handleExport from '@/common/mixins/handle-export'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
export default {
  mixins: [ActionLine, SearchMixin, handleExport],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {},
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/promote/display-direct/index.vue